// encryption.service.ts

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
import { goToSessionlessLanding } from '../utils/auth-landing';

@Injectable({
    providedIn: 'root'
})
export class EncryptionService {

    private eKey: any;

    constructor(private router: Router) { }

    getSecretKey() {
        // if (localStorage.getItem('ekey')!) {
        const key = new Uint8Array(32);
        crypto.getRandomValues(key);
        const encodedKey = Array.from(key)
            .map(byte => byte.toString(16).padStart(2, '0'))
            .join('');
        this.eKey = encodedKey;
        localStorage.setItem("ekey", this.eKey);
        // }
        this.eKey = localStorage.getItem('ekey');
        return this.eKey;
    }

    encryptData(data: any): string {
        if (localStorage.getItem('ekey')) {
            this.eKey = localStorage.getItem('ekey');
        }
        else {
            this.eKey = this.getSecretKey();
        }

        const encryptedData = AES.encrypt(JSON.stringify(data), this.eKey).toString();
        return encryptedData;
    }

    decryptData(encryptedData: string): any {
        try {
            this.eKey = localStorage.getItem('ekey');
            
            if ((!encryptedData || encryptedData === 'undefined' || encryptedData === 'null') && localStorage.getItem('isGuestUser')) {
              // Only clear for real guest users who have stale state.
              // Never clear for demo users — they legitimately have no 'user' key
              // and clearing would destroy their isDemoUser / isGuestUser / 'e' / 'u' flags
              // mid-upload, breaking everything.
              if (!localStorage.getItem('isDemoUser')) {
                localStorage.clear();
              }
              return null;
            }

            // Check if encryptedData is valid
            if (!encryptedData || encryptedData === 'undefined' || encryptedData === 'null') {
                // console.warn('Invalid encrypted data provided to decryptData'); //__CONSOLE_LOG__
                return null;
            }

            const decryptedData = AES.decrypt(encryptedData, this.eKey == null ? "" : this.eKey);
            const decryptedString = decryptedData.toString(Utf8);
            
            // Check if decryption resulted in empty string
            if (!decryptedString || decryptedString.trim() === '') {
                // console.warn('Decryption resulted in empty string'); //__CONSOLE_LOG__
                return null;
            }

            let user = localStorage.getItem('user');
            if (user == "null" || user === null) {
                // In guest flow, do not navigate to login
                const isGuest = localStorage.getItem('isGuestUser') === 'true' || sessionStorage.getItem('isGuestUser') === 'true';
                const isDemoUser = localStorage.getItem('isDemoUser') === 'true';
                // '/flipbook/' is the public shared-book page — no session there
                // is the normal state, not a reason to bounce to login.
                // Includes window.location.hash because router.url is still '/'
                // while the first navigation is in flight.
                const routeUrl = (this.router.url || '') + ' ' + (window.location.hash || '');
                const onGuestRoute = routeUrl.includes('/guest/') || routeUrl.includes('demo-event') || routeUrl.includes('demo-landing') || routeUrl.includes('demo-direct-gallery') || routeUrl.includes('/flipbook/');
                if (!(isGuest || isDemoUser || onGuestRoute)) {
                    // console.log('called from auth service - user is null'); //__CONSOLE_LOG__
                    goToSessionlessLanding(this.router);
                }
                return null;
            } else {
                const decryptedObject = JSON.parse(decryptedString);
                return decryptedObject;
            }
        } catch (error) {
            // console.error('Error in decryptData:', error); //__CONSOLE_LOG__
            // console.error('Encrypted data:', encryptedData); //__CONSOLE_LOG__
            return null;
        }
    }

    decryptRsvpData(encryptedData: string): any {
        try {
            this.eKey = localStorage.getItem('ekey');
            
            // Check if encryptedData is valid
            if (!encryptedData || encryptedData === 'undefined' || encryptedData === 'null') {
                // console.warn('Invalid encrypted data provided to decryptRsvpData'); //__CONSOLE_LOG__
                return null;
            }

            const decryptedData = AES.decrypt(encryptedData, this.eKey == null ? "" : this.eKey);
            const decryptedString = decryptedData.toString(Utf8);
            
            // Check if decryption resulted in empty string
            if (!decryptedString || decryptedString.trim() === '') {
                // console.warn('Decryption resulted in empty string in decryptRsvpData'); //__CONSOLE_LOG__
                return null;
            }

            const decryptedObject = JSON.parse(decryptedString);
            // console.log("decrypted and parsed", JSON.parse(decryptedObject) //__CONSOLE_LOG__);
            return decryptedObject;
        } catch (error) {
            // console.error('Error in decryptRsvpData:', error); //__CONSOLE_LOG__
            // console.error('Encrypted data:', encryptedData); //__CONSOLE_LOG__
            return null;
        }
    }
}
